import React, { useState } from 'react';
import {
  GoogleMap,
  LoadScript,
  Marker,
} from '@react-google-maps/api';
import {
  inject,
  observer,
} from 'mobx-react';
import { withTranslation } from 'react-i18next';
import LoadingButton from '../../components/LoadingButton/LoadingButton';

const API_MAP_KEY = process.env.REACT_APP_API_MAP_KEY;

function Map(props) {
  const { settingsStore, weatherStore, notifierStore, t } = props;
  const [ lat, setLat ] = useState(settingsStore.configuration.latitude || 41.083047);
  const [ lng, setLng ] = useState(settingsStore.configuration.longitude || -73.518675);
  const [ loading, setLoading ] = useState(false);

  const mapContainerStyle = {
    height: '60vh',
    width: '100%',
  };

  const position = {
    lat,
    lng,
  };

  const onDragEnd = marker => {
    setLat(marker.latLng.lat());
    setLng(marker.latLng.lng());
  };

  const saveLocation = () => {
    setLoading(true);
    settingsStore.configuration.latitude = lat;
    settingsStore.configuration.longitude = lng;

    weatherStore.getCurrentWeather()
      .then(() => {
        settingsStore.configuration.locationName = `${weatherStore.city},${weatherStore.country}`;
        settingsStore.saveConfiguration({ ...settingsStore.configuration })
          .then(() => {
            notifierStore.showSuccess({ key: 'Plant location saved', props: { location: settingsStore.configuration.locationName }});
          })
          .finally(() => {
            setLoading(false);
          });
      });
  };

  return (
    <div>
      <div>
        <LoadScript
          id="script-loader"
          googleMapsApiKey={API_MAP_KEY}
        >
          <GoogleMap
            id="marker-example"
            mapContainerStyle={mapContainerStyle}
            zoom={10}
            center={position}
          >
            <Marker
              position={position}
              draggable={true}
              onDragEnd={onDragEnd}
            />
          </GoogleMap>
        </LoadScript>
      </div>
      <div className="text-right margin-top-10">
        <LoadingButton bsStyle={'primary'}
          onClick={saveLocation}
          isLoading={loading}
          loadingLabel={t('Saving')}
          label={t('Save')}/>
      </div>
    </div>
  );
}

export default withTranslation()(inject('settingsStore', 'weatherStore', 'notifierStore')(observer(Map)));
